import React, {Component} from "react"
import {Col} from "react-bootstrap"
import PropTypes from "prop-types"

import {CompanyNewsTile} from "@irati/types"
import authentication from "@irati/auth"

import HomePageRow from "../HomePageRow"
import {HomePageView} from "../types"
import {HOMEPAGE_TOUR_PREFIX} from "../../../tour"
import ContentColumns from "./Content/ContentColumns"
import Title from "./Title"
import companyNewsToRows from "./utils/companyNewsToRows"
import {isRowEmpty} from "./utils/isRowEmpty"
import Empty from "./Empty"

interface Props {
  companyNews: CompanyNewsTile[],
  id: string,
  pageView: HomePageView,
  toggleEditView: () => void
}

class HomepageTiles extends Component<Props> {
  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  handleClick = () => {
    this.props.toggleEditView()
  }

  render() {
    const {companyNews, id, pageView} = this.props
    const rows = companyNewsToRows(companyNews)
    const filteredRowsWithContent = rows.filter((tiles: CompanyNewsTile[]) => !isRowEmpty(tiles))
    const areFilteredRowsEmpty = filteredRowsWithContent.length === 0
    const canEdit = authentication.apps("platform.cultureHub.update")

    if (areFilteredRowsEmpty && !canEdit) {
      return null
    }

    return (
      <HomePageRow id={id} data-tour={`${HOMEPAGE_TOUR_PREFIX}-step02`} isEditRowView={false}>
        <Col xs={12}>
          <Title onClickEdit={this.handleClick} />
          {areFilteredRowsEmpty && <Empty onClick={this.handleClick} />}
          {filteredRowsWithContent.map((companyNewsRow, i: number) => (
            <ContentColumns companyNewsRow={companyNewsRow} pageView={pageView} key={i} />
          ))}
        </Col>
      </HomePageRow>
    )
  }
}

export default HomepageTiles
